/**
 * Utility class to centralize notification payloads
 */

export function success(message) {
    return {
        color: 'green',
        textColor: 'white',
        icon: 'cloud_done',
        message: message,
    }
}

export function warning(message) {
    return {
        color: 'red',
        textColor: 'white',
        icon: 'warning',
        message: message,
    }
}